


<template>
  <v-dialog v-model="show" :fullscreen="true" :dark="true">
    <div style="height: 100%; background-color: black" id="preso1">
      <div class="reveal deck1">
        <div class="slides">
          <weather v-if="facility && facility.presentation_showweather" />

          <scorecard ref="scorecard" />

          <offline ref="offline" />

          <harvests ref="harvests" />

          <alerts1 ref="alerts1" />

          <late-irrigations ref="lateIrrigations" />

          <vfus ref="vfus" />

          <stocks
            v-model="facility.presentation_stocks"
            v-if="facility && facility.presentation_stocks"
            ref="stocks"
          />

          <clock v-if="facility && facility.presentation_showclock" />
        </div>
      </div>
      <div
        @click="show=false"
        style="
          background: url(/img/AgrifyLogo.svg);
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          bottom: 70px;
          right: 70px;
          width: 70px;
          height: 70px;
        "
      />
    </div>
  </v-dialog>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Trimaster from "@/plugins/servers/trimaster.js";
import Reveal from "reveal.js";
import Scorecard from "./Scorecard.vue";
import Vfus from "./Vfus.vue";
import Harvests from "./Harvests.vue";
import Alerts1 from "./Alerts1.vue";
import Offline from "./Offline.vue";
import LateIrrigations from "./LateIrrigations.vue";
import Clock from "./Clock.vue";
import Weather from "./Weather.vue";
import Stocks from "./Stocks.vue";

export default {
  name: "",
  props: ["value"],
  components: {
    Scorecard,
    Vfus,
    Alerts1,
    Harvests,
    Offline,
    LateIrrigations,
    Clock,
    Weather,
    Stocks,
  },
  data() {
    return {
      facility: null,
      show: false,
      revealInstance: null,
      timer: null,
      initialized: false,
    };
  },
  beforeMount() {
    this.getFacility();
  },
  mounted() {},
  destroyed() {
    this.initialized=false;
    this.revealInstance = null;
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {
    show(newVal, oldVal) {
      if (!newVal) {
        this.$emit("input", false);
      } else {
        if (this.initialized) {
          this.doReveal();
        }
      }
    },
    value: {
      handler: function (newVal, oldVal) {
        let me = this;
        if (newVal) {
          this.show = true;
          this.timer = setInterval(this.refresh, 90000);
          let me = this;
          setTimeout(() => {
            this.doReveal();
            this.initialized = true;
          }, 1500);
        } else {
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    getFacility() {
      let me = this;
      Trimaster.get(
        "facilities/" + me.getUser.facility_id,
        me.getUser.apitoken
      ).then(function ([res, err]) {
        me.facility = res;
      });
    },

    doReveal() {
      let me = this;
      const config = {
        controls: false,
        help: false,
        autoPlayMedia: true,
        loop: true,
        autoSlide: 8000,
        overview: false,
      };

      // the problem is that we're getting the first item created
      if (!this.revealInstance) {
        this.revealInstance = new Reveal(document.querySelector(".deck1"), {
          embedded: true,
        });
        this.revealInstance.initialize(config);
      }

      // this.revealInstance.sync();
      this.revealInstance.toggleOverview(false);
      this.revealInstance.toggleAutoSlide(true);

      // this.revealInstance.slide(0); - causes bug to manifiest in reveal.js
      // this.revealInstance.sync();

    },
    refresh() {
      this.getFacility();
      this.$refs.scorecard.refresh();
      this.$refs.alerts1.refresh();
      this.$refs.vfus.refresh();
      this.$refs.offline.refresh();
      this.$refs.harvests.refresh();
      this.$refs.lateIrrigations.refresh();
      if (this.$refs.stocks) {
        this.$refs.stocks.refresh();
      }
    },
  },
};
</script>

<style lang="scss">
</style>
